
export class ChangeDetails{
    poNumber:string;
   
}